module.exports = __webpack_public_path__ + "img/logo.226d908c.png";